import type { Country } from "./Country"
import { allCountries } from "./Country"

export function isCountry(country?: unknown): country is Country {
	return country !== undefined && typeof country === "string" && allCountries.includes(country as Country)
}
